var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',[_c('list-bar',{attrs:{"title":"最新资讯","items":_vm.news}})],1),_c('el-col',[_c('list-bar',{attrs:{"title":"联系我们","items":_vm.contact}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }